
import { Button } from "@/components/ui/button";
import { UserX, UserCheck } from "lucide-react";

interface AccountStatusButtonProps {
  isActive: boolean;
  canSelfReactivate: boolean;
  onDeactivate: () => void;
  onReactivate: () => void;
}

export const AccountStatusButton = ({
  isActive,
  canSelfReactivate,
  onDeactivate,
  onReactivate,
}: AccountStatusButtonProps) => {
  return (
    <Button
      variant={isActive ? "destructive" : "default"}
      onClick={isActive ? onDeactivate : onReactivate}
      className="flex items-center justify-center gap-2 min-h-[44px] w-full sm:w-auto"
      disabled={!isActive && !canSelfReactivate}
    >
      {isActive ? (
        <>
          <UserX className="h-4 w-4" />
          Deactivate Account
        </>
      ) : (
        <>
          <UserCheck className="h-4 w-4" />
          Reactivate Account
        </>
      )}
    </Button>
  );
};
